import { ErrorWrapper, FieldErrorMessage, StyledErrorIcon } from './styles';
import { FieldErrorProps } from './types';

export const FieldError = ({ errorMessage, id, role }: FieldErrorProps) => {
    return (
        <ErrorWrapper id={id} role={role}>
            <StyledErrorIcon role="presentation" aria-hidden="true" />
            <FieldErrorMessage>{errorMessage}</FieldErrorMessage>
        </ErrorWrapper>
    );
};
